import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DeleteBankModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (otp: string) => void;
}

const DeleteBankModal: React.FC<DeleteBankModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const [otp, setOtp] = useState('');
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (otp.length === 6) {
      onConfirm(otp);
      setOtp('');
    }
  };

  const handleClose = () => {
    onClose();
    setOtp('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 !bg-black/50 flex items-center justify-center z-50">
      <div className="!bg-white dark:!bg-gray-800 rounded-md p-6 w-full max-w-md mx-4 shadow-xl">
        <div className="flex items-start justify-between mb-4">
          <h3 className="!text-lg !font-semibold !text-gray-900 dark:!text-white">
            {t('payment.billing.delete_bank_account')}
          </h3>
          <button
            onClick={handleClose}
            className="!bg-transparent !border-none !text-gray-400 hover:!text-gray-600 dark:hover:!text-gray-300 !p-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-4 mb-6">
          <p className="!text-sm !text-gray-600 dark:!text-gray-400">
            {t('payment.billing.delete_bank_account_otp_description')}
          </p>
          <div>
            <label className="block !text-sm !font-medium !text-gray-700 dark:!text-gray-300 mb-1">
              Mã OTP
            </label>
            <input
              type="text"
              placeholder="VD: 123456"
              maxLength={6}
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ''))}
              className="w-full !px-4 !py-2.5 !border !border-gray-300 dark:!border-gray-600 rounded-md !bg-white dark:!bg-gray-700 !text-gray-900 dark:!text-white placeholder:!text-gray-400 focus:!outline-none focus:!ring-2 focus:!ring-blue-500 text-center tracking-widest text-lg font-bold"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleClose}
            className="flex-1 !px-4 !py-2.5 !border !border-gray-300 dark:!border-gray-600 rounded-md !text-gray-700 dark:!text-gray-300 hover:!bg-gray-50 dark:hover:!bg-gray-700 !transition-colors !bg-white dark:!bg-gray-800 !font-medium"
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={handleConfirm}
            disabled={otp.length < 6}
            className={`flex-1 !px-4 !py-2.5 !text-white rounded-md !transition-colors !border-none !font-medium ${
              otp.length < 6 ? '!bg-red-400 !cursor-not-allowed' : '!bg-red-600 hover:!bg-red-700'
            }`}
          >
            {t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteBankModal;
